/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CustomerCareExecutive from './customer-care-executive';
import CustomerCareExecutiveDetail from './customer-care-executive-detail';
import CustomerCareExecutiveUpdate from './customer-care-executive-update';
import CustomerCareExecutiveDeleteDialog from './customer-care-executive-delete-dialog';

const CustomerCareExecutiveRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CustomerCareExecutive />} />
    <Route path="new" element={<CustomerCareExecutiveUpdate />} />
    <Route path=":id">
      <Route index element={<CustomerCareExecutiveDetail />} />
      <Route path="edit" element={<CustomerCareExecutiveUpdate />} />
      <Route path="delete" element={<CustomerCareExecutiveDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CustomerCareExecutiveRoutes;
